import React from 'react';

function FileList({ files, onFileSelect, selectedFile }) {
  return (
    <div className="file-list">
      <h3>Available Files</h3>
      <ul>
        {files.map(file => (
          <li 
            key={file.id} 
            className={selectedFile?.id === file.id ? 'selected' : ''}
          >
            <a 
              href="#" 
              onClick={(e) => {
                e.preventDefault();
                onFileSelect(file);
              }}
              style={{ cursor: 'pointer' }}
            >
              {file.name}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default FileList;